// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Icon from 'components/atoms/Icon'
import Message from 'components/atoms/Message'
import Description from 'components/atoms/Description'

const Container = styled.div`
  ${({ hasError }) =>
    hasError &&
    css`
      .ant-input {
        border-color: ${Colors.red};
        background-color: #ffeff5;
      }
    `};
`
const FooterWrapper = styled.div`
  margin-top: ${spacing.small_2}px;
`
const ErrorText = styled.span`
  font-size: ${fontSize.small_2}px;
  color: ${Colors.red};
  line-height: 1.3;
`
const Label = styled.p`
  margin-bottom: ${spacing.small_3}px;
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
`
const Before = styled.span`
  display: inline-block;
  margin-right: ${spacing.small_2}px;
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
`
const Unit = styled.span`
  display: inline-block;
  margin-left: ${spacing.small_2}px;
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
`
const ErrorsWrapper = styled.div`
  margin-top: ${spacing.small_2}px;
`
const ErrorTextWrapper = styled.div`
  &:not(:first-child) {
    margin-top: ${spacing.tiny}px;
  }

  a {
    padding-bottom: 1px;
    color: ${Colors.red};
    border-bottom: 1px solid ${Colors.red};
  }
`

export const renderErrorText = (errorText: string, index: number = 0) => (
  <Message errorText={errorText} />
)

export const renderFooterText = (footerText: string, index: number = 0) => (
  <Description key={index}>{footerText}</Description>
)

type PropTypes = {
  renderInput?: Function,
  label?: string,
  unit?: string,
  beforeText?: string,
  footerTexts?: ?Array<string>,
  errorTexts?: ?Array<string>,
  isShowIllegalStayErrorTexts?: ?boolean,
}

export default (props: PropTypes) => (
  <Container
    hasError={Array.isArray(props.errorTexts) && props.errorTexts.length > 0}
  >
    {props.label && <Label>{props.label}</Label>}
    {props.beforeText && <Before>{props.beforeText}</Before>}
    {props.renderInput && props.renderInput()}
    {props.unit && <Unit>{props.unit}</Unit>}
    {Array.isArray(props.footerTexts) && (
      <FooterWrapper>{props.footerTexts.map(renderFooterText)}</FooterWrapper>
    )}
    {Array.isArray(props.errorTexts) &&
      props.errorTexts.length > 0 && (
        <ErrorsWrapper>
          {props.errorTexts.map((text, i) => (
            <ErrorTextWrapper key={`form_error_text${i}`}>
              {renderErrorText(text)}
            </ErrorTextWrapper>
          ))}
        </ErrorsWrapper>
      )}
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/molecules/FormItem/index.jsx